import ConfigurationPage from "/src/features/administration/configuration/components/ConfigurationPage";

function ConfigurationList() {
    return <ConfigurationPage />;
}

export default ConfigurationList;
